import { Component, ViewChild, AfterContentChecked } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart } from '@angular/router';
import { userdocserviceopp } from '../../../_services/userservice/user.documentupload.service';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Identificationtype } from '../../../models/User/documentupload/user.documentupload.model';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { AboutUsComponent } from '../../../sharedcomponents/about-us/about-us.component';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AppSettings, enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
import * as moment from 'moment';
import { FancyImageUploaderOptions, UploadedFile, Status, FancyImageUploaderComponent } from 'ng2-fancy-image-uploader';
import { ErrorPopupComponent } from '../../../sharedcomponents/_directive/error-popup/error-popup.component';
import { InfoPopupComponent } from '../../../sharedcomponents/_directive/info-popup/info-popup.component';
import { UserService } from '../../../_services/userservice/user.service';
import { countrycodetoname } from '../../../sharedcomponents/_pipe/country';
import { DomSanitizer } from '@angular/platform-browser';
import { StatelistComponent } from '../../../sharedcomponents/_common/countrylist/statelist.component';


declare var $: any;
export class DocumentModalContext extends BSModalContext {
  public modalData: any = {};
}
@Component({
  templateUrl: './userprofile-document-upload.component-Step2.html',
  providers: [userdocserviceopp, AlertService, Modal, UserService, utilityService]
})
export class uploaddocumtuserprofilestep2 implements AfterContentChecked, ModalComponent<DocumentModalContext> {
  @ViewChild('imageUploader', { read: FancyImageUploaderComponent })
  imageUploader: FancyImageUploaderComponent;
  @ViewChild('imageUploaderBack', { read: FancyImageUploaderComponent })
  imageUploaderBack: FancyImageUploaderComponent;

  imageDataFront: any = {};
  imageDataBack: any = {};
  saveDocModel: any = {};
  filterstates: any;
  selectedState: any;
  countryMask: any;
  url: any;
  yearRange = '';
  minDateValue;
  docServiceSubscription: any;
  target = '';
  docUploadinfo: any;
  filterStateValue = false;
  isFrontImageUploaded = false;
  isBackImageUploaded = false;
  frontImageData: any;
  backImageData: any;
  countryList: any = [];
  documentList: any = [];
  options: FancyImageUploaderOptions = {
    thumbnailHeight: 150,
    thumbnailWidth: 150,
    uploadUrl: null,
    allowedImageTypes: ['image/png', 'image/jpeg'],
    maxImageSize: 15,
    autoUpload: false
  };

  constructor(
    public dialog: DialogRef<DocumentModalContext>,
    public modal: Modal,
    public utilServ: utilityService,
    private userdoc: userdocserviceopp,
    private alertService: AlertService,
    public translate: TranslateService,
    private userService: UserService,
    private router: Router,
    public domSanitizer: DomSanitizer
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.saveDocModel = dialog.context.modalData.docUploadinfo;
  }

  ngOnInit() {
    this.getUserDocumentsList();
    this.utilServ.busy = this.userdoc.getcountrydoucmenttypelistrequest(AppSettings.BaseCountry, this.saveDocModel.TypeName).subscribe(data => {
      this.docUploadinfo = this.userdoc.populateDocumentModelStep1(data);
      let countrycode = new countrycodetoname();

      let docUploadinfoTemp =[];
      this.docUploadinfo.filter(data => {
        if (countrycode.checkCountryObj(data.IssuerConCode) != null) {
          docUploadinfoTemp.push( data);
        }
      });
      this.docUploadinfo = docUploadinfoTemp;
      this.countryList = docUploadinfoTemp.map(data => {
        // return data.IssuerConCode;

        if (countrycode.checkCountryObj(data.IssuerConCode) != null) {
          return data.IssuerConCode;
        }
      });


      // this.onCountryChange(this.saveDocModel.IssuerConCode);
      this.filterstates = this.docUploadinfo.filter(item => item.IssuerConCode == this.saveDocModel.IssuerConCode);
      if (this.filterstates.filter(item => item.IssuerStateCode != '' && item.IssuerStateCode != null).length > 0) {
        this.filterStateValue = true;
      }
      this.imageDataFront = JSON.parse(JSON.stringify(this.saveDocModel));
      this.imageDataFront.ImageType = 'jpeg';
      this.imageDataFront.UploadType = 0;
      this.imageDataFront.ImageData = '';

      this.imageDataBack = JSON.parse(JSON.stringify(this.saveDocModel));
      this.imageDataBack.ImageType = 'jpeg';
      this.imageDataBack.UploadType = 0;
      this.imageDataBack.ImageData = '';

      if (this.saveDocModel.DocumentID > 0) {
        this.loadDocImage(this.saveDocModel.FrontImageUrl, this.saveDocModel.BackImageUrl);
      }
    });
    //  this.minDateValue =  new Date().getDate() + 1;

    this.yearRange = new Date().getFullYear() + ':' + (new Date().getFullYear() + 100);
    //  this.updateImgInstruction();
  }

  openStateBox() {
    let self = this;
    let modalData: any = {};
    modalData.CountryCode = this.saveDocModel.IssuerConCode;
    return this.modal.open(StatelistComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next.StateCode == undefined) {
        } else {
          self.saveDocModel.IssuerStateCode = modalData.next.StateCode;
          self.selectedState = modalData.next.StateName;
          //self.onStateChange(modalData.next.StateCode);
        }
      });
    });
  }

  getUserDocumentsList() {
    this.userService.getUserDocumets().subscribe(data => {
      const resJSON = data;
      if (resJSON.Envelope.Body.DocumentInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        this.documentList = this.utilServ.getArray(resJSON.Envelope.Body.DocumentInfoResponse.Documents.DocumentInfo);
      }
    });
  }

  isDocAlreadyExist() {
    let flag = false;
    try {
      if (this.saveDocModel.DocumentID > 0) {
        return false;
      }
    } catch (error) { }

    let curDocObj = this.documentList.filter(item => {
      return this.utilServ.getObjectText(item.DocumentType) == this.saveDocModel.TypeName;
    });
    if (curDocObj.length > 0) {
      if (curDocObj[0].IssuerCountryCode == this.saveDocModel.IssuerConCode) {
        flag = true;
      } else {
        flag = false;
      }
    } else {
      flag = false;
    }
    return flag;
  }

  submitButton() {
    const _self = this;
    if (this.isDocAlreadyExist() == true) {
      let modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblConfirm').toString();
      modalData.Message =
        this.translate.instant('DocumentDetail_SameDocumentPre') +
        ' ' +
        this.saveDocModel.TypeName +
        ' ' +
        this.translate.instant('DocumentDetail_SameDocumentMid') +
        ' ' +
        new countrycodetoname().transform(this.saveDocModel.IssuerConCode);
      +' ' + this.translate.instant('DocumentDetail_SameDocumentPost');

      return this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.next == 'yes') {
            _self.savedoc();
          } else {
            _self.dialog.context.modalData.Status = false;
            _self.dialog.close();
          }
        });
      });
    } else {
      this.savedoc();
    }
  }
  savedoc() {
    const _self = this;
    let temMask: any;
    let selectedDoc: any;

    if (this.utilServ.getObjectText(this.saveDocModel.IssuerStateCode) != '') {
      selectedDoc = this.docUploadinfo.filter(item => {
        return item.IssuerStateCode == this.saveDocModel.IssuerStateCode;
      })[0];
    } else {
      selectedDoc = this.docUploadinfo.filter(item => {
        return item.IssuerConCode == this.saveDocModel.IssuerConCode;
      })[0];
    }

    // check valid document identification pattern
    if (this.utilServ.validateDocNumPattern(this.saveDocModel.DocumentNumber) == true) {
      this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Common_lblIdentification'));
      return false;
    }

    temMask = selectedDoc.Masks;
    // Mask Check
    let isPatternMatch = false;
    for (const element of temMask) {
      const pat = this.utilServ.getPattern(this.utilServ.getObjectText(element.Prefix), element.Mask, this.utilServ.getObjectText(element.Suffix));
      const regexp = new RegExp(pat);
      if (regexp.test(this.saveDocModel.DocumentNumber) === true) {
        isPatternMatch = true;
        break;
      }
    }
    if (this.saveDocModel.FrontImage) {
      if (this.imageDataFront.ImageData == '' || this.imageDataFront.ImageData == null || this.imageDataFront.ImageData == undefined) {
        this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('DocImageRequirePopup_desc'));
        return false;
      }
    }
    if (this.saveDocModel.BackImage) {
      if (this.imageDataBack.ImageData == '' || this.imageDataBack.ImageData == null || this.imageDataBack.ImageData == undefined) {
        this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('DocImageRequirePopup_desc'));
        return false;
      }
    }

    if (isPatternMatch == true) {
      if (this.saveDocModel.RequiresExpirationDate == true) {
        this.saveDocModel.ExpirationDate = moment(this.saveDocModel.ExpirationDate).format('L');
      }

      this.utilServ.busy = this.userdoc.saveuserdocument(this.saveDocModel).subscribe(data => {
        const resJSON = data;
        if (resJSON.Envelope.Body.DocumentInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          _self.imageDataFront.DocumentID = resJSON.Envelope.Body.DocumentInfoResponse.DocumentID;
          _self.imageDataFront.DocumentNumber = _self.saveDocModel.DocumentNumber;
          if (_self.imageDataFront.ImageData != '') {
            _self.utilServ.busy = _self.userdoc.savedocImage(_self.imageDataFront).subscribe(data => {
              if (data.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
                if (_self.saveDocModel.BackImage) {
                  _self.imageDataBack.UploadType = 1;
                  _self.imageDataBack.DocumentID = resJSON.Envelope.Body.DocumentInfoResponse.DocumentID;
                  _self.imageDataBack.DocumentNumber = _self.saveDocModel.DocumentNumber;
                  _self.utilServ.busy = _self.userdoc.savedocImage(_self.imageDataBack).subscribe(data => {
                    if (data.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
                      let modalData: any = {};
                      modalData.Title = this.translate.instant('Common_lblThankyou').toString();
                      modalData.Message = this.translate.instant('DocReviewPopup_desc').toString();
                      return this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                        obj.onDestroy.subscribe(data => {
                          _self.dialog.context.modalData.Status = true;
                          _self.dialog.close();
                        });
                      });
                    } else {
                      _self.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
                    }
                  });
                } else {
                  if (_self.dialog.context.modalData.isProfile == true) {
                    _self.dialog.context.modalData.Status = true;
                    _self.dialog.close();
                    return;
                  }
                  let modalData: any = {};
                  modalData.Title = this.translate.instant('Common_lblThankyou').toString();
                  modalData.Message = this.translate.instant('DocReviewPopup_desc').toString();
                  return this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                      _self.dialog.context.modalData.Status = true;
                      _self.dialog.close();
                    });
                  });
                }
              } else {
                _self.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
              }
            });
          } else {
            // if doc uploaded successfully withoot front and back images
            if (_self.dialog.context.modalData.isProfile == true) {
              _self.dialog.context.modalData.Status = true;
              _self.dialog.close();
              return;
            }
            let modalData: any = {};
            modalData.Title = this.translate.instant('Common_lblThankyou').toString();
            modalData.Message = this.translate.instant('DocReviewPopup_desc').toString();
            return this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
              obj.onDestroy.subscribe(data => {
                _self.dialog.context.modalData.Status = true;
                _self.dialog.close();
              });
            });
          }
        } else {
          _self.errorPopup(this.translate.instant('Common_lblOops'), resJSON.Envelope.Body.DocumentInfoResponse.StatusMessage);
        }
      });
    } else {
      this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Common_lblIdentification'));
    }
  }

  onCountryChange(value) {
    this.saveDocModel.IssuerStateCode="";
    let countryCode = value.currentTarget.value == '' ? value.currentTarget.value : value.currentTarget.value.split(':')[1].trim();
    this.filterstates = this.docUploadinfo.filter(item => item.IssuerConCode == countryCode);
    if (this.filterstates.filter(item => item.IssuerStateCode != '' && item.IssuerStateCode != null).length > 0) {
      this.filterStateValue = true;
    }
  }

  onStateChange(event) {
    this.selectedState = event.target.selectedOptions[0].text;
  }

  closePopup() {
    this.dialog.context.modalData.Status = false;
    this.dialog.close();
  }
  openHowtoUploadImg(urlText) {
    let modalData: any = {};
    modalData.Title = ''; // this.translate.instant('popupTitle_HowtoUploadImagesPopup');
    modalData.URL = urlText;
    modalData.Action = this.translate.instant('Common_lblOk');
    return this.modal.open(AboutUsComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => { });
    });
  }

  imageUploaderStatusChangedFront(status: Status) {
   console.log("hi");
    if (status === Status.NotSelected) {
      this.imageDataFront = JSON.parse(JSON.stringify(this.saveDocModel));
      this.imageDataFront.ImageType = 'jpeg';
      this.imageDataFront.UploadType = 0;
      this.imageDataFront.ImageData = '';
    }
    if (this.imageUploader.fileToUpload == undefined) {
      return false;
    }
    const self = this;
    if (status === Status.Selected) {
      this.imageDataFront = JSON.parse(JSON.stringify(this.saveDocModel));
      // this.imageDataFront.ImageType = this.imageUploader.fileToUpload.type.split('/')[1];
      this.imageDataFront.UploadType = 0;

      let arrayBuffer;
      let fileReader = new FileReader();
      fileReader.onload = function (f) {
        let currentTarget: any = f.currentTarget;
        arrayBuffer = currentTarget.result; //this.result;
        // self.imageDataFront.ImageData = btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
        let uarr = new Uint8Array(arrayBuffer);
        let strings = [],
          chunksize = 0xffff;
        let len = uarr.length;
        // There is a maximum stack size. We cannot call String.fromCharCode with as many arguments as we want
        for (let i = 0; i * chunksize < len; i++) {
          strings.push(String.fromCharCode.apply(null, uarr.subarray(i * chunksize, (i + 1) * chunksize)));
        }

        // self.imageDataFront.ImageData = btoa(strings.join(''));
        // self.imageDataFront.ImageType = self.guessImageMime(self.imageDataFront.ImageData);
        self.utilServ.busy = self.utilServ.jicCompressImage(btoa(strings.join('')), 50, self.imageUploader.fileToUpload.type,self.imageUploader.fileToUpload.size).subscribe(
          data => {
            self.imageDataFront.ImageData = data.split(',')[1];
            self.imageDataFront.ImageType = self.guessImageMime(self.imageDataFront.ImageData);
          },
          error => { }
        );

        // self.imageUploader.imageThumbnail = 'data:image/gif;base64,' + self.imageDataFront.ImageData;
      };
      fileReader.readAsArrayBuffer(this.imageUploader.fileToUpload);
    } else if (status === Status.Loaded) {
      this.imageDataFront = JSON.parse(JSON.stringify(this.saveDocModel));
      // this.imageDataFront.ImageType =this.imageUploader.imageThumbnail.split(';')[0].split('/')[1]
      // this.imageDataFront.UploadType = 0;
    } else {
      this.imageDataFront = JSON.parse(JSON.stringify(this.saveDocModel));
      this.imageDataFront.ImageType = 'jpeg';
      this.imageDataFront.UploadType = 0;
      this.imageDataFront.ImageData = '';
    }
    //this.updateImgInstruction();
  }

  imageUploaderStatusChangedBack(status: Status) {
console.log("hi");
    
    if (status === Status.NotSelected) {
      this.imageDataBack = JSON.parse(JSON.stringify(this.saveDocModel));
      this.imageDataBack.ImageType = 'jpeg';
      this.imageDataBack.UploadType = 0;
      this.imageDataBack.ImageData = '';
    }
    if (this.imageUploaderBack.fileToUpload == undefined) {
      return false;
    }
    
    //this.updateImgInstruction();
    const self = this;
    if (status === Status.Selected) {
      this.imageDataBack = JSON.parse(JSON.stringify(this.saveDocModel));
      // this.imageDataBack.ImageType = this.imageUploaderBack.fileToUpload.type.split('/')[1];
      this.imageDataBack.UploadType = 1;
;
      let arrayBuffer;
      let fileReader = new FileReader();
      fileReader.onload = function (f) {
        let currentTarget: any = f.currentTarget;
        arrayBuffer = currentTarget.result; //this.result;
        // self.imageDataBack.ImageData = btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
        let uarr = new Uint8Array(arrayBuffer);
        let strings = [],
          chunksize = 0xffff;
        let len = uarr.length;
        // There is a maximum stack size. We cannot call String.fromCharCode with as many arguments as we want
        for (let i = 0; i * chunksize < len; i++) {
          strings.push(String.fromCharCode.apply(null, uarr.subarray(i * chunksize, (i + 1) * chunksize)));
        }

        // self.imageDataBack.ImageData = btoa(strings.join(''));
        // self.imageDataBack.ImageType = self.guessImageMime(self.imageDataBack.ImageData);
        self.utilServ.busy = self.utilServ.jicCompressImage(btoa(strings.join('')), 50, self.imageUploaderBack.fileToUpload.type, self.imageUploader.fileToUpload.size).subscribe(
          data => {
            self.imageDataBack.ImageData = data.split(',')[1];
            self.imageDataBack.ImageType = self.guessImageMime(self.imageDataBack.ImageData);
          },
          error => { }
        );

        // self.imageUploaderBack.imageThumbnail = 'data:image/gif;base64,' + self.imageDataBack.ImageData;
      };
      fileReader.readAsArrayBuffer(this.imageUploaderBack.fileToUpload);
    } else if (status === Status.Loaded) {
      this.imageDataBack = JSON.parse(JSON.stringify(this.saveDocModel));
    } else {
      this.imageDataBack = JSON.parse(JSON.stringify(this.saveDocModel));
      this.imageDataBack.ImageType = 'jpeg';
      this.imageDataBack.UploadType = 1;
      this.imageDataBack.ImageData = '';
    }
    //this.updateImgInstruction();
  }
  loadDocImage(frontsuffix, backsuffix) {
    console.log("hi");
    
    this.saveDocModel.FrontImage = true;
    const self = this;

    if (frontsuffix != '') {
      this.utilServ.busy = this.utilServ.getIceImage(frontsuffix).subscribe(
        res => {
          if (res == null || res == undefined) return;
          let urlCreator = window.URL;
          let imageUrl = urlCreator.createObjectURL(res);

          try {
            // self.imageUploader.loadAndResize(imageUrl);
          } catch (error) { }

          let arrayBuffer;
          let fileReader = new FileReader();
          fileReader.onload = function (f) {
            let currentTarget: any = f.currentTarget;
            arrayBuffer = currentTarget.result; //this.result;
            let uarr = new Uint8Array(arrayBuffer);
            let strings = [],
              chunksize = 0xffff;
            let len1 = uarr.length;
            // There is a maximum stack size. We cannot call String.fromCharCode with as many arguments as we want
            for (let i = 0; i * chunksize < len1; i++) {
              strings.push(String.fromCharCode.apply(null, uarr.subarray(i * chunksize, (i + 1) * chunksize)));
            }
            self.imageDataFront = self.saveDocModel;
            self.imageDataFront.ImageData = btoa(strings.join(''));
            self.imageDataFront.ImageType = self.guessImageMime(self.imageDataFront.ImageData);
            self.imageUploader.imageThumbnail = 'data:image/gif;base64,' + self.imageDataFront.ImageData;
          };
          fileReader.readAsArrayBuffer(res);
        },
        error => { }
      );
    }

    if (backsuffix != '') {
      this.saveDocModel.BackImage = true;
      if (this.docUploadinfo[0].BackImage != undefined) {
        this.saveDocModel.BackImage = this.docUploadinfo[0].BackImage;
      }
      if (this.saveDocModel.BackImage == false) {
        return false;
      }
      this.utilServ.busy = this.utilServ.getIceImage(backsuffix).subscribe(
        res => {
          if (res == null || res == undefined) return;
          let urlCreator = window.URL;
          let imageUrl = urlCreator.createObjectURL(res);

          try {
            // self.imageUploaderBack.loadAndResize(imageUrl);
          } catch (error) { }

          let arrayBuffer;
          let fileReader = new FileReader();
          fileReader.onload = function (f) {
            let currentTarget: any = f.currentTarget;
            arrayBuffer = currentTarget.result; //this.result;
            let uarr = new Uint8Array(arrayBuffer);
            let strings = [],
              chunksize = 0xffff;
            let len = uarr.length;
            // There is a maximum stack size. We cannot call String.fromCharCode with as many arguments as we want
            for (let i = 0; i * chunksize < len; i++) {
              strings.push(String.fromCharCode.apply(null, uarr.subarray(i * chunksize, (i + 1) * chunksize)));
            }
            self.imageDataBack = self.saveDocModel;
            self.imageDataBack.ImageData = btoa(strings.join(''));
            self.imageDataBack.ImageType = self.guessImageMime(self.imageDataBack.ImageData);
            self.imageUploaderBack.imageThumbnail = 'data:image/gif;base64,' + self.imageDataBack.ImageData;
          };
          fileReader.readAsArrayBuffer(res);
          ;
        },
        error => { }
      );
    }
  }
  guessImageMime(data) {
    return 'jpeg';
    // if (data.charAt(0) == '/') {
    //   return 'jpeg';
    // } else if (data.charAt(0) == 'R') {
    //   return 'gif';
    // } else if (data.charAt(0) == 'i') {
    //   return 'png';
    // }
  }



  errorPopup(title, message) {
    let modalData: any = {};
    modalData.Title = title;
    modalData.Message = message;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  ngAfterContentChecked() {
    try {
      let isfirstImageLoaded = $('.upload_img_lhs .image-container:nth-child(1) .match-parent .remove').length; //$('div.match-parent .remove').length;
      let collection = $('div.match-parent p:nth-child(2)');
      if (collection.length > 0 && isfirstImageLoaded == 0) {
        collection[0].innerHTML = this.translate.instant('DocumentDetail_lblFrontUpload');
      }
      if (collection.length > 1) {
        collection[1].innerHTML = this.translate.instant('DocumentDetail_lblRearUpload');
      }
      if (isfirstImageLoaded == 1) {
        collection[0].innerHTML = this.translate.instant('DocumentDetail_lblRearUpload');
      }
    } catch (error) { }
  }
  // updateImgInstruction() {
  //   var collection = $('div.match-parent p:nth-child(2)');
  //   if (collection.length > 0) {
  //     collection[0].innerHTML = this.translate.instant('lblFrontUpload');
  //   }
  //   if (collection.length > 1) {
  //     collection[1].innerHTML = this.translate.instant('lblRearUpload');
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/user-document-upload/userprofile-document-upload.component-Step2.ts